export const messages = {
	justNow: '0 minuti fa',
	past: n => (n.match(/\d/) ? `${n} fa` : n),
	future: n => (n.match(/\d/) ? `tra ${n}` : n),
	month: (n, past) =>
		n === 1 ? (past ? 'lo scorso mese' : 'il prossimo mese') : `${n} mes${n > 1 ? 'i' : 'e'}`,
	year: (n, past) =>
		n === 1 ? (past ? 'lo scorso anno' : 'il prossimo anno') : `${n} ann${n > 1 ? 'i' : 'o'}`,
	day: (n, past) => (n === 1 ? (past ? 'ieri' : 'domani') : `${n} giorn${n > 1 ? 'i' : 'o'}`),
	week: (n, past) =>
		n === 1
			? past
				? 'la scorsa settimana'
				: 'la prossima settimana'
			: `${n} settiman${n > 1 ? 'e' : 'a'}`,
	hour: n => `${n} or${n > 1 ? 'e' : 'a'}`,
	minute: n => `${n} minut${n > 1 ? 'i' : 'o'}`,
	second: n => `${n} second${n > 1 ? 'i' : 'o'}`,
}
